import { Component, OnInit, Input, Inject } from '@angular/core';
import { CategoryService } from 'src/app/_service/category.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';

@Component({
  selector: 'app-subscription-modal',
  templateUrl: './subscription-modal.component.html',
  styleUrls: ['./subscription-modal.component.css']
})
export class SubscriptionModalComponent implements OnInit {

  channelId: string;
  channelName: string;
  channelCurrency: string;
  channelCurrencySymbol: string;
  vidLibId:string;
  plans: any;
  uniqueFeatures: any[] = [];
  selectedOption: any;
  vipPlans: any[] = [];
  premiumPlans: any[] = [];
  selectedDuration: string = ''; 
  sortedPlans: any[] = []; 
  planBgMap = {
    Free: './assets/subscriptions/standard_bg.svg',
    Standard: './assets/subscriptions/standard_bg.svg', 
    VIP: './assets/subscriptions/vip_bg.svg',
    Premium: './assets/subscriptions/premium_bg.svg'
  }

  planMobileBgMap = {
    Free: './assets/subscriptions/mobile_free_bg.svg',
    Standard: './assets/subscriptions/mobile_standard_bg.svg', 
    VIP: './assets/subscriptions/mobile_vip_bg.svg',
    Premium: './assets/subscriptions/mobile_premium_bg.svg'
  }
  selectedPlan:any = null;

  constructor(
    private categService: CategoryService,
    private router: Router,
    private route: ActivatedRoute,
    private whitelabelService: WhiteLabelService,
    private bridgeService: IosBridgeService
    ) { 
    }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params)=>{
      console.log(params)
      this.channelId = params['channelId'];
      this.channelName = params['channelName'];
      this.vidLibId = params['vidLibId'];
    })
    if(this.channelId){
      console.log(this.channelId)
      this.getPlans();
      console.log(this.channelId)
    }
  }

  getPlanBg(planName:string): string{
    return this.planBgMap[planName] || '';
  }

  getMobilePlanBg(planName:string): string{
    return this.planMobileBgMap[planName] || '';
  }

  getFeatureSymbol(featureDescription: string): string {
    switch (featureDescription) {
      case 'Y':
        return '✔'; 
      case 'N':
        return '✖'; 
      default:
        return featureDescription; 
    }
  }
  
  getDurationDisplayName(durationName: string): string {
    const mapping: { [key: string]: string } = {
      '1 Day': 'Daily',
      '1 Month': 'Monthly',
      '3 Months': 'Quarterly',
      '6 Months': 'Half-Yearly',
    };

    return mapping[durationName] || durationName; 
  }

  getPlanCost(plan: any) {
    const option = plan.options.find((o: any) => o.durationName === this.selectedDuration);
    return option ? option.cost : '--';
  }

  sortPlans(plans: any[]): any[] {
    const planOrder = ['Free', 'VIP', 'Premium', 'Standard'];
    return plans.sort((a, b) => {
      const aIndex = planOrder.indexOf(a.planName);
      const bIndex = planOrder.indexOf(b.planName);
      
      const aPos = aIndex === -1 ? planOrder.length : aIndex;
      const bPos = bIndex === -1 ? planOrder.length : bIndex;
      
      return aPos - bPos;
    });
  }

  getPlans() {
    this.categService.channelData(this.channelId).subscribe((result: any) => {
      if (result.responseCode === 200) {
        this.channelCurrency = result.responseDto[0]?.currencyCode;
        this.channelCurrencySymbol = result.responseDto[0]?.currencySymbol;
        this.plans = result.responseDto[0].availableSubscriptionPlans;
        console.log('plans', this.plans);
  
        this.sortedPlans = this.sortPlans([...this.plans]);
        this.selectedDuration = this.plans[0]?.options[0]?.durationName;
      }
    });
  }
  
  // getPlans() {
  //   this.plans = this.categService.channelPlans(this.channelId);
  //   console.log('plans', this.plans);
  //   this.sortedPlans = this.sortPlans([...this.plans]); 
  //   this.selectedDuration = this.plans[0]?.options[0]?.durationName;
  //   console.log(this.selectedDuration);
  // }

  selectPlan(plan: any) {
    if (this.selectedPlan?.planName === plan.planName) {
      this.selectedPlan = null;
    } else {
      this.selectedPlan = plan; 
    }
  }  

  openPayments(plan:any, selectedDuration:any) {
    console.log(plan, selectedDuration)
    const selectedOption = plan.options.filter((option)=>{
      if(option.durationName === selectedDuration){
        return option
      }
    })
    console.log(selectedOption);
    const route = this.whitelabelService.getPrefixedRoute('payment');
    if (this.bridgeService.isIOS()) {
      console.log("you are insdie the ios");
      const payload = {
        "action": "fetchProduct",
      };
      this.bridgeService.sendIosPaymentDetails(payload);
    }
    this.router.navigate([route], {
      queryParams: {
        type: 'channel',
        contentType: plan.planName,
        channelId: plan.channelId,
        channel: this.channelName,
        subId: plan.subscriptionId,
        durId: selectedOption[0].durationId,
        planAmount: selectedOption[0].cost,
        durationName: selectedOption[0].durationName,
        vidLibId: this.vidLibId? this.vidLibId : '',
        currency: this.channelCurrency,
        currencySymbol: this.channelCurrencySymbol
      }
    });
  }  
}